// @ts-nocheck
/**
 * New MagFlow - KV 双视频 + 发布倒计时 + 留邮表单 + 规则弹窗 + Gleam 弹窗 + 入场渐显
 */
(function () {
  'use strict';

  const TAG_NAME = 'new-magflow-section';
  if (customElements.get(TAG_NAME)) return;
  const FORM_SUBMIT_URL = 'https://ecf.cirkleinc.com/api/form-submit';
  const MOBILE_MQ = '(max-width: 1023.98px)';
  const GLEAM_SCRIPT_SRC = 'https://widget.gleamjs.io/e.js';

  /** 规则弹窗与 Gleam 弹窗共用滚动锁，按当前是否有打开的弹窗统一同步 */
  function syncScrollLock() {
    const hasOpen = !!document.querySelector(
      '.ug-new-magflow__modal:not([hidden]), .ug-new-magflow__gleam:not([hidden])'
    );
    document.documentElement.classList.toggle('ug-nmf-modal-open', hasOpen);
  }

  function playInlineVideo(video) {
    /* iOS 需要静音属性齐全才允许内联自动播放 */
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    window.requestAnimationFrame(() =>
      window.requestAnimationFrame(() => {
        if (!video.isConnected) return;
        const played = video.play();
        if (played) played.catch(() => {});
      })
    );
  }

  /** KV 双视频：按断点只播放对应那条，播放起来后淡入盖住 poster */
  function bindKvVideo(kv) {
    if (kv.dataset.nmfKvInited === '1') return;
    kv.dataset.nmfKvInited = '1';

    const posterImg = kv.querySelector('.ug-new-magflow__kv-poster');
    const posterPicture = kv.querySelector('.ug-new-magflow__kv-picture');
    let lastIsMobile = null;
    let raf = 0;

    const sync = () => {
      const isMobile = window.matchMedia(MOBILE_MQ).matches;
      if (lastIsMobile === isMobile) return;
      lastIsMobile = isMobile;

      const active = kv.querySelector(
        isMobile ? '.ug-new-magflow__kv-video--mo' : '.ug-new-magflow__kv-video--pc'
      );
      const inactive = kv.querySelector(
        isMobile ? '.ug-new-magflow__kv-video--pc' : '.ug-new-magflow__kv-video--mo'
      );

      if (inactive) {
        inactive.pause();
        inactive.preload = 'none';
        inactive.classList.remove('is-visible');
      }

      const src = active && active.querySelector('source');
      if (!active || !src || !src.getAttribute('src')) return;

      active.preload = 'auto';

      const reveal = () => {
        if (!active.isConnected) return;
        const stillActive = kv.querySelector(
          window.matchMedia(MOBILE_MQ).matches
            ? '.ug-new-magflow__kv-video--mo'
            : '.ug-new-magflow__kv-video--pc'
        );
        if (stillActive !== active) return;
        active.classList.add('is-visible');
        if (posterImg) posterImg.classList.add('is-hidden');
        if (posterPicture) posterPicture.classList.add('is-hidden');
        playInlineVideo(active);
      };

      if (active.readyState >= 3) {
        reveal();
      } else {
        active.addEventListener('canplay', reveal, { once: true });
        active.load();
      }
    };

    const scheduleSync = () => {
      if (raf) window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(() => {
        raf = 0;
        sync();
      });
    };

    scheduleSync();

    const onResize = () => scheduleSync();
    window.addEventListener('resize', onResize, { passive: true });

    kv._nmfKvCleanup = () => {
      window.removeEventListener('resize', onResize);
      if (raf) window.cancelAnimationFrame(raf);
      raf = 0;
      kv.querySelectorAll('video').forEach((video) => video.pause());
      delete kv.dataset.nmfKvInited;
      delete kv._nmfKvCleanup;
    };
  }

  /** Gleam 组件脚本按需注入一次，全站共用 */
  function ensureGleamScript() {
    if (window.__nmfGleamScriptPromise) return window.__nmfGleamScriptPromise;

    const existing = document.querySelector(
      'script[data-nmf-gleam-loader], script[data-sr-gleam-loader]'
    );

    window.__nmfGleamScriptPromise = new Promise((resolve) => {
      if (existing) {
        if (existing.dataset.loaded === '1') {
          resolve();
          return;
        }
        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', resolve, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = GLEAM_SCRIPT_SRC;
      script.async = true;
      script.dataset.nmfGleamLoader = 'true';
      script.onload = () => {
        script.dataset.loaded = '1';
        resolve();
      };
      script.onerror = resolve;
      document.head.appendChild(script);
    });

    return window.__nmfGleamScriptPromise;
  }

  function closeGleamPopup(popup) {
    popup.hidden = true;
    syncScrollLock();
    const lastFocus = popup._nmfGleamLastFocus;
    delete popup._nmfGleamLastFocus;
    if (lastFocus && document.contains(lastFocus)) {
      window.requestAnimationFrame(() => lastFocus.focus());
    }
  }

  function openGleamPopup(popup) {
    if (popup.hidden && document.activeElement instanceof HTMLElement) {
      popup._nmfGleamLastFocus = document.activeElement;
    }
    popup.hidden = false;
    syncScrollLock();

    const closeButton = popup.querySelector('.ug-new-magflow__gleam-close');
    if (closeButton) window.requestAnimationFrame(() => closeButton.focus());

    /* Gleam 组件按容器宽度自适应，展开后需要触发一次重算 */
    ensureGleamScript().then(() => window.dispatchEvent(new Event('resize')));
  }

  function bindGleamPopup(popup) {
    if (popup.dataset.nmfGleamInited === '1') return;
    popup.dataset.nmfGleamInited = '1';

    const closeEls = popup.querySelectorAll('[data-nmf-gleam-close]');
    const onClose = () => closeGleamPopup(popup);
    const onDocKeydown = (e) => {
      if (e.key === 'Escape' && !popup.hidden) {
        e.preventDefault();
        closeGleamPopup(popup);
      }
    };

    closeEls.forEach((el) => el.addEventListener('click', onClose));
    document.addEventListener('keydown', onDocKeydown, true);

    popup._nmfGleamCleanup = () => {
      closeEls.forEach((el) => el.removeEventListener('click', onClose));
      document.removeEventListener('keydown', onDocKeydown, true);
      closeGleamPopup(popup);
      delete popup.dataset.nmfGleamInited;
      delete popup._nmfGleamCleanup;
    };
  }

  function pad2(value) {
    return value < 10 ? '0' + value : String(value);
  }

  /** 后台填写的结束时间一律按北京时间解析，各地区访客倒计时指向同一时刻 */
  function parseEndTime(raw) {
    if (!raw) return NaN;
    const text = String(raw)
      .trim()
      .replace(' ', 'T')
      .replace(/(?:Z|[+-]\d{2}:?\d{2})$/i, '');
    return Date.parse(text + '+08:00');
  }

  function bindCountdown(root) {
    if (root.dataset.nmfCountdownInited === '1') return;
    root.dataset.nmfCountdownInited = '1';

    const endTime = parseEndTime(root.getAttribute('data-end'));
    const daysEl = root.querySelector('[data-nmf-days]');
    const hoursEl = root.querySelector('[data-nmf-hours]');
    const minutesEl = root.querySelector('[data-nmf-minutes]');
    const secondsEl = root.querySelector('[data-nmf-seconds]');

    if (!Number.isFinite(endTime) || !daysEl || !hoursEl || !minutesEl || !secondsEl) return;

    let timer = 0;

    const render = () => {
      const diff = endTime - Date.now();

      if (diff <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        root.classList.add('is-ended');
        window.clearInterval(timer);
        timer = 0;
        return;
      }

      const totalSeconds = Math.floor(diff / 1000);
      daysEl.textContent = pad2(Math.floor(totalSeconds / 86400));
      hoursEl.textContent = pad2(Math.floor(totalSeconds / 3600) % 24);
      minutesEl.textContent = pad2(Math.floor(totalSeconds / 60) % 60);
      secondsEl.textContent = pad2(totalSeconds % 60);
    };

    render();
    timer = window.setInterval(render, 1000);

    root._nmfCountdownCleanup = () => {
      window.clearInterval(timer);
      timer = 0;
      delete root.dataset.nmfCountdownInited;
      delete root._nmfCountdownCleanup;
    };
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email);
  }

  function bindEmailBlock(block, root) {
    if (block.dataset.nmfEmailInited === '1') return;
    block.dataset.nmfEmailInited = '1';

    const submitBtn = block.querySelector('.ug-new-magflow__email-submit');
    const input = block.querySelector('.ug-new-magflow__email-input');
    if (!submitBtn || !input) return;

    const privacyCheckbox = block.querySelector('.ug-new-magflow__email-checkbox');
    const errorMsg = block.querySelector('.ug-new-magflow__email-error');
    const successMsg = block.querySelector('.ug-new-magflow__email-message');

    const formId = block.getAttribute('data-form-id') || '';
    const successGleamId = block.getAttribute('data-success-gleam-id');
    /* 后台清空文案时不能弹出空提示，这里保留英文兜底 */
    const successText = block.getAttribute('data-success-text') || 'Thanks for subscribing!';
    const failText =
      block.getAttribute('data-fail-text') || 'Subscription failed, please try again later.';
    const privacyError =
      block.getAttribute('data-privacy-error') || 'Please agree to the privacy policy.';
    const emailError =
      block.getAttribute('data-email-error') || 'Please enter a valid email address.';

    const showError = (msg) => {
      errorMsg.textContent = msg;
      errorMsg.style.display = 'block';
      successMsg.style.display = 'none';
    };

    const showSuccess = (msg) => {
      successMsg.textContent = msg;
      successMsg.style.display = 'block';
      errorMsg.style.display = 'none';
    };

    const trackSubscription = (isSuccess) => {
      const track = window.ugGa4Track;
      if (!track || typeof track.subscriptionEvent !== 'function') return;
      try {
        track.subscriptionEvent({ isSuccess, position: 'new-magflow' });
      } catch (_) {}
    };

    const onSubmit = async () => {
      if (submitBtn.classList.contains('loading')) return;

      const email = input.value.trim();
      if (!isValidEmail(email)) {
        showError(emailError);
        return;
      }
      if (privacyCheckbox && !privacyCheckbox.checked) {
        showError(privacyError);
        return;
      }

      errorMsg.style.display = 'none';
      successMsg.style.display = 'none';
      submitBtn.classList.add('loading');
      submitBtn.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(FORM_SUBMIT_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email,
            accepts_marketing: privacyCheckbox && privacyCheckbox.checked ? 'on' : 'off',
            form_id: formId
          })
        });

        /* 接口异常时可能返回非 JSON，需单独兜住解析失败 */
        let data = null;
        try {
          data = await response.json();
        } catch (_) {
          showError(failText);
          trackSubscription(false);
          return;
        }

        const isSuccess = data && data.status === 'success';
        if (isSuccess) {
          input.value = '';
          if (privacyCheckbox) privacyCheckbox.checked = false;
          showSuccess(successText);
          if (successGleamId) {
            const popup = root.querySelector(
              '[data-nmf-gleam-popup="' + CSS.escape(successGleamId) + '"]'
            );
            if (popup) openGleamPopup(popup);
          }
        } else {
          const serverMsg =
            (data && data.errors && data.errors.email && data.errors.email[0]) ||
            (data && data.message) ||
            failText;
          showError(serverMsg);
        }
        trackSubscription(!!isSuccess);
      } catch (_) {
        showError(failText);
        trackSubscription(false);
      } finally {
        submitBtn.classList.remove('loading');
        submitBtn.removeAttribute('aria-busy');
      }
    };

    const onKeydown = (e) => {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      onSubmit();
    };

    submitBtn.addEventListener('click', onSubmit);
    input.addEventListener('keydown', onKeydown);

    block._nmfEmailCleanup = () => {
      submitBtn.removeEventListener('click', onSubmit);
      input.removeEventListener('keydown', onKeydown);
      submitBtn.classList.remove('loading');
      submitBtn.removeAttribute('aria-busy');
      delete block.dataset.nmfEmailInited;
      delete block._nmfEmailCleanup;
    };
  }

  /** 规则弹窗：打开 / 关闭 / Esc / 焦点恢复 */
  function bindTermsModal(signupSection) {
    if (signupSection.dataset.nmfTermsInited === '1') return;

    const openBtn = signupSection.querySelector('[data-nmf-terms-open]');
    if (!openBtn) return;
    const modalId = openBtn.getAttribute('aria-controls');
    const modal = modalId
      ? document.getElementById(modalId)
      : signupSection.querySelector('[data-nmf-terms-modal]');
    if (!modal) return;

    signupSection.dataset.nmfTermsInited = '1';

    const closeEls = modal.querySelectorAll('[data-nmf-terms-close]');
    let lastFocus = null;

    const open = () => {
      lastFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      modal.hidden = false;
      syncScrollLock();
      openBtn.setAttribute('aria-expanded', 'true');
      const first = modal.querySelector('button, [href], [tabindex]:not([tabindex="-1"])');
      if (first) window.requestAnimationFrame(() => first.focus());
    };

    const close = () => {
      modal.hidden = true;
      syncScrollLock();
      openBtn.setAttribute('aria-expanded', 'false');
      const target = lastFocus && document.contains(lastFocus) ? lastFocus : openBtn;
      lastFocus = null;
      target.focus();
    };

    const onDocKeydown = (e) => {
      if (e.key === 'Escape' && !modal.hidden) {
        e.preventDefault();
        close();
      }
    };

    openBtn.addEventListener('click', open);
    closeEls.forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', onDocKeydown, true);

    signupSection._nmfTermsCleanup = () => {
      openBtn.removeEventListener('click', open);
      closeEls.forEach((el) => el.removeEventListener('click', close));
      document.removeEventListener('keydown', onDocKeydown, true);
      modal.hidden = true;
      syncScrollLock();
      openBtn.setAttribute('aria-expanded', 'false');
      delete signupSection.dataset.nmfTermsInited;
      delete signupSection._nmfTermsCleanup;
    };
  }

  /** 进视口后按时长淡入，不跟手拖进度 */
  const NMF_REVEAL = Object.freeze({
    y: 28,
    duration: 1.05,
    ease: 'cubic-bezier(0.22, 1, 0.36, 1)',
    start: 'top 82%',
    stagger: 0.1,
    titleSweepDuration: 1.2
  });

  const NMF_TITLE_SWEEP = Object.freeze({
    startPos: [100, 144, 158, 200, 220],
    endPos: [-120, -76, -62, -20, 0]
  });

  function readTitleSweepColors(title) {
    const styles = window.getComputedStyle(title);
    return [
      styles.getPropertyValue('--ug-nmf-title-start').trim() || '#ffffff',
      styles.getPropertyValue('--ug-nmf-title-mid-1').trim() || '#70b8ff',
      styles.getPropertyValue('--ug-nmf-title-mid-2').trim() || '#70b8ff',
      styles.getPropertyValue('--ug-nmf-title-end').trim() || '#70b8ff'
    ];
  }

  function titleSweepGradient(progress, colors) {
    const pos = NMF_TITLE_SWEEP.startPos.map((start, index) =>
      (start + (NMF_TITLE_SWEEP.endPos[index] - start) * progress).toFixed(2)
    );
    return (
      'linear-gradient(-90deg, ' +
      colors[0] +
      ' ' +
      pos[0] +
      '%, ' +
      colors[1] +
      ' ' +
      pos[1] +
      '%, ' +
      colors[2] +
      ' ' +
      pos[2] +
      '%, ' +
      colors[3] +
      ' ' +
      pos[3] +
      '%, ' +
      colors[0] +
      ' ' +
      pos[4] +
      '%)'
    );
  }

  function applyTitleSweep(title, progress, colors) {
    title.style.setProperty('--ug-nmf-title-current', titleSweepGradient(progress, colors));
  }

  function finishTitleSweep(title) {
    const sweepEl = title.querySelector('.ug-new-magflow__tiles-title-text');
    title.style.setProperty('--ug-nmf-title-current', 'var(--ug-nmf-title-fill)');
    if (sweepEl) sweepEl.style.visibility = 'visible';
  }

  const REVEAL_SELECTORS = [
    '.ug-new-magflow__kv-headline',
    '.ug-new-magflow__countdown',
    '.ug-new-magflow__timeline',
    '.ug-new-magflow__mail',
    '.ug-new-magflow__terms',
    '[data-nmf-title-sweep]',
    '.ug-new-magflow__tile',
    '.ug-new-magflow__legal'
  ].join(',');

  /** 无 GSAP 或用户要求减动效时直接落到终态，避免内容停留在隐藏状态 */
  function showRevealFinal(root) {
    root.querySelectorAll(REVEAL_SELECTORS).forEach((el) => {
      el.style.opacity = '1';
      el.style.transform = 'none';
      el.style.visibility = 'visible';
    });
    const title = root.querySelector('[data-nmf-title-sweep]');
    if (title) finishTitleSweep(title);
  }

  /** 淡入按实际进入视口的内容分组触发，所有分组共用同一套节奏参数 */
  function initReveal(root) {
    const gsap = window.gsap;
    const ScrollTrigger = window.ScrollTrigger;

    if (!gsap || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      showRevealFinal(root);
      return;
    }

    if (ScrollTrigger) gsap.registerPlugin(ScrollTrigger);

    const timelines = [];
    const fromVars = { autoAlpha: 0, y: NMF_REVEAL.y };
    const toVars = {
      autoAlpha: 1,
      y: 0,
      duration: NMF_REVEAL.duration,
      ease: NMF_REVEAL.ease
    };

    const createTimeline = (trigger) => {
      const timeline = gsap.timeline({
        scrollTrigger:
          ScrollTrigger && trigger
            ? {
                trigger,
                start: NMF_REVEAL.start,
                once: true,
                invalidateOnRefresh: true
              }
            : undefined
      });
      timelines.push(timeline);
      return timeline;
    };

    const revealGroup = (trigger, elements) => {
      const els = elements.filter(Boolean);
      if (!els.length) return;
      gsap.set(els, fromVars);
      createTimeline(trigger).to(els, { ...toVars, stagger: NMF_REVEAL.stagger });
    };

    /* KV 在首屏，无需等待滚动 */
    revealGroup(null, [
      root.querySelector('.ug-new-magflow__kv-headline'),
      root.querySelector('.ug-new-magflow__countdown')
    ]);

    const signup = root.querySelector('.ug-new-magflow__signup');
    if (signup) {
      const timeline = signup.querySelector('.ug-new-magflow__timeline');
      const mail = signup.querySelector('.ug-new-magflow__mail');
      const terms = signup.querySelector('.ug-new-magflow__terms');

      revealGroup(timeline, [timeline]);
      revealGroup(mail, [mail]);
      revealGroup(terms, [terms]);
    }

    const title = root.querySelector('[data-nmf-title-sweep]');
    if (title) {
      const sweepEl = title.querySelector('.ug-new-magflow__tiles-title-text');
      const sweepColors = readTitleSweepColors(title);
      const sweepTween = { current: null };
      const fadeTween = { current: null };
      const titleObservers = [];
      let titleFaded = false;
      let titleInView = false;

      const stopTitleSweep = () => {
        if (sweepTween.current) {
          sweepTween.current.kill();
          sweepTween.current = null;
        }
      };

      const resetTitleSweep = () => {
        stopTitleSweep();
        applyTitleSweep(title, 0, sweepColors);
      };

      const playTitleSweep = () => {
        stopTitleSweep();
        const sweepState = { p: 0 };
        applyTitleSweep(title, 0, sweepColors);
        sweepTween.current = gsap.to(sweepState, {
          p: 1,
          duration: NMF_REVEAL.titleSweepDuration,
          ease: 'none',
          onUpdate() {
            applyTitleSweep(title, sweepState.p, sweepColors);
          },
          onComplete() {
            finishTitleSweep(title);
            sweepTween.current = null;
          }
        });
      };

      applyTitleSweep(title, 0, sweepColors);
      if (sweepEl) gsap.set(sweepEl, fromVars);

      const titleEnter = () => {
        titleInView = true;
        if (!titleFaded) {
          titleFaded = true;
          if (sweepEl) {
            fadeTween.current = gsap.to(sweepEl, {
              ...toVars,
              clearProps: 'transform',
              onComplete() {
                fadeTween.current = null;
                if (titleInView) playTitleSweep();
              }
            });
            return;
          }
        }
        playTitleSweep();
      };

      const titleLeave = () => {
        titleInView = false;
        resetTitleSweep();
      };

      const stopTitleReveal = () => {
        if (fadeTween.current) {
          fadeTween.current.kill();
          fadeTween.current = null;
        }
        stopTitleSweep();
        titleObservers.forEach((observer) => observer.disconnect());
        titleObservers.length = 0;
      };

      if ('IntersectionObserver' in window) {
        /* 进入视口就扫；离开后重置，再进来再扫一次。往回滚从上方进入也要播 */
        const playObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) titleEnter();
            });
          },
          { rootMargin: '0px 0px -18% 0px', threshold: 0 }
        );
        const resetObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) titleLeave();
            });
          },
          { threshold: 0 }
        );
        playObserver.observe(title);
        resetObserver.observe(title);
        titleObservers.push(playObserver, resetObserver);
        timelines.push({ kill: stopTitleReveal });
      } else {
        titleEnter();
        timelines.push({ kill: stopTitleReveal });
      }
    }

    const wideTile = root.querySelector('.ug-new-magflow__tile--wide');
    if (wideTile) revealGroup(wideTile, [wideTile]);

    const halfTiles = Array.from(root.querySelectorAll('.ug-new-magflow__tile--half'));
    if (halfTiles.length) {
      revealGroup(halfTiles[0].closest('.ug-new-magflow__tiles-row'), halfTiles);
    }

    const legal = root.querySelector('.ug-new-magflow__legal');
    if (legal) revealGroup(legal, [legal]);

    if (ScrollTrigger) {
      window.requestAnimationFrame(() => ScrollTrigger.refresh());
    }

    root._nmfRevealCleanup = () => {
      timelines.forEach((timeline) => {
        if (timeline.scrollTrigger) timeline.scrollTrigger.kill();
        timeline.kill();
      });
      timelines.length = 0;
      delete root._nmfRevealCleanup;
    };
  }

  function runCleanup(root, selector, key) {
    root.querySelectorAll(selector).forEach((el) => {
      if (typeof el[key] === 'function') el[key]();
    });
  }

  class NewMagflowSection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.nmfInited === '1') return;
      this.dataset.nmfInited = '1';

      this.querySelectorAll('[data-nmf-kv]').forEach(bindKvVideo);
      this.querySelectorAll('[data-nmf-countdown]').forEach(bindCountdown);
      this.querySelectorAll('[data-nmf-gleam-popup]').forEach(bindGleamPopup);
      this.querySelectorAll('[data-nmf-email]').forEach((el) => bindEmailBlock(el, this));
      this.querySelectorAll('.ug-new-magflow__signup').forEach(bindTermsModal);
      initReveal(this);
    }

    disconnectedCallback() {
      delete this.dataset.nmfInited;
      runCleanup(this, '[data-nmf-kv]', '_nmfKvCleanup');
      runCleanup(this, '[data-nmf-countdown]', '_nmfCountdownCleanup');
      runCleanup(this, '[data-nmf-email]', '_nmfEmailCleanup');
      runCleanup(this, '[data-nmf-gleam-popup]', '_nmfGleamCleanup');
      runCleanup(this, '.ug-new-magflow__signup', '_nmfTermsCleanup');
      if (this._nmfRevealCleanup) this._nmfRevealCleanup();
    }
  }

  customElements.define(TAG_NAME, NewMagflowSection);
})();
